import { render } from "./configurations.vue?vue&type=template&id=73a4c06c&ts=true"
import script from "./configurations.vue?vue&type=script&lang=ts"
export * from "./configurations.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__